function Footer(){
    return <>
         <hr color="black"></hr>
      <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
    <div class="me-5 d-none d-lg-block">
      <span>Created by @Silviyadev, © 2023</span>
    </div>

    <div>
      <a href="https://www.linkedin.com/in/silviya-s-frontenddev/" rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-linkedin fa-lg m-3 black-color"></i>  
      </a>
      <a href="https://github.com/SilviyaS"  rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-github fa-lg m-3 black-color"></i>
      </a>
      <a href="https://medium.com/@silviyafrontenddev" rel="noreferrer"  target="_blank"  class="me-4 text-reset">
      <i class="bi bi-medium fa-lg m-3 black-color"></i>
            </a>
      <a href="https://twitter.com/20ec_s" rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-twitter fa-lg m-3 black-color"></i>
            </a>
      <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=GTvVlcRzDDMSRvCgmFnVRXqjhhqKFmfpXShbfGVgKtpKgdMFnrfJKMjMNWmjBsFmZNhPHldptVvbg"  rel="noreferrer"  target="_blank" class="me-4 text-reset">
      <i class="bi bi-envelope fa-lg m-3 black-color"></i>
            </a>
    </div>
  </section>
    </>
}

export default Footer;